import { NftStandard } from './nftToken.interface'

/**
 * Contract names recognized by MPRO Lab backend + frontend.
 * Strings map 1:1 to documents in the `configuration.contracts` Mongo collection.
 */
export enum MprolabContractName {
  MPRO = 'MPRO',
  USDC = 'USDC',
  MPRO_REFERRAL = 'MPROReferral',
  MPRO_AUTO_STAKE = 'MPRORewardStake',
  MPRO_DUAL_AUTO_STAKE = 'MPRODoubleRewardAutoStake',
  MPRO_STAKE = 'MPROStake',
  MPRO_DOUBLE_STAKE = 'MPRODoubleRewardStake',
  MPRO_REWARD_PROXY = 'MPRORewardProxy',
  UNISWAP_ROUTER = 'UniswapRouter',
  NODE_OWNERS = 'NodeOwners',
  MGA_REGULAR_NODES = 'MGARegularNodes',
  LIGHT_NODES = 'LightNodes',
  REGULAR_NODES = 'RegularNodes',
  /** Scope 14: the marketplace fee vault, one per licence collection (iNODE today). */
  MPRO_FEE_VAULT = 'MPROFeeVault',
  /** The fee-taking swap router on Base (scope 16). */
  MPRO_SWAP_ROUTER = 'MPROSwapRouter',
}

export interface MprolabContract {
  name: string
  standard: NftStandard
  address: string
  isActive: boolean
  chainId: number
  creationBlock?: number
}
